
<div
  echarts
  class="echarts mt-1"
  [options]="option"
  style="height: 100px; width: 100%"
></div>
